import React from 'react'

import { Flex } from 'app/components/design-system-components'
import { UCSProviderConfig } from 'app/constants/ucs.constants'
import ActivityCubeListItem from 'app/dashboard/team_activity/activity_cube_list_item/component'

const ActivityCubeList = ({
  enquiriesTotal = 0,
  viewersTotal = 0,
  applicationsTotal = 0,
  viewingsTotal = 0,
  propertyOffersTotal = 0,
  utilityProvider,
  sentUtilityReferrals = 0,
  vacantProperties = 0,
  enquiriesGroupTotal = 0,
  showEnquiriesGroup = false,
}) => {
  const ucsProviderConfig = UCSProviderConfig[utilityProvider]
  const UcsProviderIcon = ucsProviderConfig?.icon

  const providerIcon = UcsProviderIcon ? (
    <Flex
      width="80px"
      height="38px"
      alignItems="center"
      justifyContent="flex-end"
    >
      <UcsProviderIcon width="100%" height="100%" />
    </Flex>
  ) : null

  return (
    <Flex mt={6} flexWrap="wrap">
      <ActivityCubeListItem
        header={'Properties listed'}
        value={propertyOffersTotal}
      />
      <ActivityCubeListItem header={'Enquiries'} value={enquiriesTotal} />
      {showEnquiriesGroup && (
        <ActivityCubeListItem
          header={'Enquiries (Group)'}
          value={enquiriesGroupTotal}
        />
      )}
      <ActivityCubeListItem header={'Viewings'} value={viewingsTotal} />
      <ActivityCubeListItem header={'Attendees'} value={viewersTotal} />
      <ActivityCubeListItem header={'Applications'} value={applicationsTotal} />
      <ActivityCubeListItem
        header="Vacant Properties (Now)"
        value={vacantProperties}
      />
      <ActivityCubeListItem
        header={'Utility Referrals'}
        value={sentUtilityReferrals}
        icon={providerIcon}
      />
    </Flex>
  )
}

export default ActivityCubeList
